module.exports = __webpack_public_path__ + "static/media/formChecked.5aae6cfa.svg";